import type { SdkUser } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';
import { checkAndRaiseWalletAccountsChangedEvent } from '../../auth/updateAuthFromVerifyResponse/checkAndRaiseWalletAccountsChangedEvent';

/**
 * Refreshes the current user's data from the server.
 *
 * This function fetches the latest authenticated user information from the backend
 * and updates the local user state.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the authenticated user.
 */
export const refreshUser = async (
  client = getDefaultClient()
): Promise<SdkUser> => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const previousState = { ...core.state.get() };

  const user = await apiClient.getAuthenticatedUser({
    environmentId: core.environmentId,
  });

  core.state.set({ user });

  checkAndRaiseWalletAccountsChangedEvent({ previousState }, client);

  return user;
};
